import { render } from "./page-home.vue?vue&type=template&id=9d1f0aba&scoped=true&lang=html"
import script from "./page-home.vue?vue&type=script&lang=js"
export * from "./page-home.vue?vue&type=script&lang=js"

import "./page-home.vue?vue&type=style&index=0&id=9d1f0aba&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-9d1f0aba"

export default script